var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7 14.7h-.137c-.582-2.943-3.216-5.167-6.33-5.167-1.711 0-3.25.684-4.414 1.745A11.61 11.61 0 0 0 15.5 10.8c-1.163 0-2.293.171-3.32.48a6.384 6.384 0 0 0-4.413-1.746c-3.114 0-5.714 2.224-6.33 5.167H1.3a1.3 1.3 0 1 0 0 2.6h.137c.582 2.943 3.216 5.167 6.33 5.167A6.462 6.462 0 0 0 14.234 16c0-.855-.171-1.677-.48-2.43a9.419 9.419 0 0 1 1.746-.17c.616 0 1.198.068 1.745.17a6.404 6.404 0 0 0-.479 2.43 6.462 6.462 0 0 0 6.467 6.467c3.114 0 5.714-2.224 6.33-5.167h.137a1.3 1.3 0 1 0 0-2.6zM7.767 19.866A3.884 3.884 0 0 1 3.901 16a3.885 3.885 0 0 1 3.866-3.867A3.885 3.885 0 0 1 11.633 16a3.884 3.884 0 0 1-3.866 3.866zm15.466 0A3.884 3.884 0 0 1 19.366 16a3.885 3.885 0 0 1 3.867-3.867A3.885 3.885 0 0 1 27.099 16a3.885 3.885 0 0 1-3.866 3.866z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.38f6178eab26e7bd7f5b309ddbc46ee3.svg";
export { ForwardRef as ReactComponent };